import { logD, logE } from "@blacknut/logging/dist";
import { DefaultNativeBridge } from "../NativeBridge";
import { PeerConnectionCommon } from "./PeerConnectionCommon";

const TAG = "AndroidPeerConnectionWrapper";
export class AndroidPeerConnectionWrapper implements PeerConnectionCommon {
  private bridge: DefaultNativeBridge;

  public peerid: number;
  constructor(
    bridge: DefaultNativeBridge,
    config: RTCConfiguration,
    peerId: number,
    streamId: string,
  ) {
    this.peerid = peerId;
    this.bridge = bridge;
    this.setPeerId(peerId, streamId).then(() => this.setPeerConfig(config));
  }

  /** Callback onIceCandidate. Public but obviously only called by android bridhe */
  public __android_onIceCandidate(payload: any) {
    this.onIceCandidateHandler &&
      this.onIceCandidateHandler({
        candidate: {
          ...payload,
          toJSON: () => payload,
        },
      } as RTCPeerConnectionIceEvent);
  }

  public __android_onReady() {
    this.onReadyHandler && this.onReadyHandler();
  }

  public __android_onPause() {
    this.onPauseHandler && this.onPauseHandler();
  }

  public __android_onResume() {
    this.onResumeHandler && this.onResumeHandler();
  }

  public addIceCandidate(data: RTCIceCandidate) {
    return this.bridge.send<void>("addIceCandidate", data);
  }
  public createOffer(data: any) {
    return this.bridge.send<RTCSessionDescriptionInit>("createOffer", data);
  }

  public setRemoteDescription(description: RTCSessionDescription) {
    return this.bridge.send<void>("setRemoteDescription", description.toJSON());
  }

  private onIceCandidateHandler?: (event: RTCPeerConnectionIceEvent) => void;
  public onIceCandidate(handler: (event: RTCPeerConnectionIceEvent) => void) {
    this.onIceCandidateHandler = handler;
  }

  private onReadyHandler?: () => void;
  public onReady(handler: () => void) {
    this.onReadyHandler = handler;
  }

  private onPauseHandler?: () => void;
  public onPause(handler: () => void) {
    this.onPauseHandler = handler;
  }

  private onResumeHandler?: () => void;
  public onResume(handler: () => void) {
    this.onResumeHandler = handler;
  }

  public setLocalDescription() {
    return Promise.resolve();
  }

  public getSenders() {
    return [];
  }

  public addTransceiver() {
    return {} as RTCRtpTransceiver;
  }

  public getStats() {
    return this.bridge.send<RTCStatsReport>("getStats", undefined);
  }

  private setPeerConfig(config: RTCConfiguration) {
    return this.bridge
      .send("setPeerConfig", config)
      .then(() => {
        //nop
        logD(TAG, "setPeerConfig OK");
      })
      .catch((e) => {
        logE(TAG, "Caught error setting config: %o", e);
      });
  }

  private setPeerId(peerId: number, streamId: string) {
    return this.bridge
      .send("setPeerId", { peerId, streamId })
      .then(() => {
        // nop
        logD(TAG, "setPeerId OK");
      })
      .catch((e) => {
        logE(TAG, "Caught error setting peerid: %o", e);
      });
  }
  public close() {
    // Here we check for the exiting tag, if Android calls exit, it does not care so much about the onStop event
    // and this prevent having error logged
    if (this.bridge.exitting) {
      this.bridge.send("close", undefined).catch((e) => {
        logD(TAG, "Caught error calling close while exiting: %o", e);
      });
    } else {
      this.bridge.send("close", undefined).catch((e) => {
        logE(TAG, "Caught error calling close: %o", e);
      });
    }
  }
}
